import {
    DashboardViewConfig as DashboardViewConfig,
    DashboardViewMode,
    dashboardViewModeConfig,
} from 'app/agriculture/routes/Devices/DeviceDetails/context/DashboardViewConfig';
import { createContext, useState } from 'react';
import { useInitialWeatherStationId } from 'app/agriculture/routes/Devices/DeviceDetails/context/useInitialWeatherStationId';

interface WeatherDashboardContextType {
    weatherStationId: string | null;
    setWeatherStationId: (value: string) => void;
    viewMode: DashboardViewMode;
    setViewMode: (viewMode: DashboardViewMode) => void;
    dashboardViewConfig: DashboardViewConfig;
}

export const WeatherDashboardContext = createContext<WeatherDashboardContextType>(
    {} as WeatherDashboardContextType,
);

export const WeatherDashboardContextProvider = ({
    children,
    initialViewMode,
}: {
    children: React.ReactNode;
    initialViewMode?: DashboardViewMode;
}) => {
    const [viewMode, setViewMode] = useState<DashboardViewMode>(initialViewMode ?? 'Week');
    const initialWeatherStationId = useInitialWeatherStationId();
    const [weatherStationId, setWeatherStationId] = useState(initialWeatherStationId);
    const dashboardViewConfig = dashboardViewModeConfig[viewMode];

    return (
        <WeatherDashboardContext.Provider
            value={{
                weatherStationId,
                setWeatherStationId,
                viewMode,
                setViewMode,
                dashboardViewConfig,
            }}
        >
            {children}
        </WeatherDashboardContext.Provider>
    );
};
